module.exports = __webpack_public_path__ + "a7063d8e1464fd5e3dbf368b31972524.otf";


//////////////////
// WEBPACK FOOTER
// ./www/app/content/themes/rikssalsstiftelsen/static/fonts/Alegreya-Bold.otf
// module id = 11
// module chunks = 0